module.exports = __webpack_public_path__ + "18c3d435fed082f66bd754b7cd206bbb.png";